export default __webpack_public_path__ + "static/media/card2.413559af.png";